import { createContext, useContext, type Context } from 'react';
// oxlint-disable-next-line eslint/no-redeclare
interface InlineContext {
	inline: boolean;
}

// Allow children component to render a block or inline Atlaskit component variant (e.g AKCode or AKCodeBlock)
export const InlineContext: Context<InlineContext> = createContext<InlineContext>({
	inline: false,
});

export const useInlineContext = (): InlineContext => useContext(InlineContext);
